import React from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';
import SortComponent from './Sort';
import SearchComponent from './Search';

import style from './index.scss';

export const SearchSortAndFilter = (props) => {
  const {
    widgetItemOperations,
    hasFilter,
    hasSort,
    hasSearch,
    applyFilterHandler,
    filters,
    alertLevels,
    moduleType = ''
  } = props;

  //Excluding for TS Module
  const filteredWidgetItemOperations = React.useMemo(() => {
    if (
      moduleType === '9' &&
      widgetItemOperations?.data?.widgetItems?.length > 0
    ) {
      const filteredItems = widgetItemOperations.data.widgetItems.map(
        (widget) => ({
          ...widget,
          itemsOperations: widget.itemsOperations.filter(
            (item) => !['partyId', 'partyName'].includes(item.itemName)
          )
        })
      );

      return {
        ...widgetItemOperations,
        data: {
          ...widgetItemOperations.data,
          widgetItems: filteredItems
        }
      };
    }

    return widgetItemOperations;
  }, [moduleType, widgetItemOperations]);

  return (
    <div className={style.flexWrapper}>
      <div className={style.filterSortWrapper}>
        {hasFilter && (
          <Filter
            GS={widgetItemOperations}
            applyFilterHandler={applyFilterHandler}
            filters={filters}
            alertLevels={alertLevels}
          />
        )}
        {/* {hasSort && <SortComponent {...props} />} */}
      </div>
      {hasSearch && (
        <SearchComponent
          {...props}
          widgetItemOperations={filteredWidgetItemOperations}
        />
      )}
    </div>
  );
};

SearchSortAndFilter.defaultProps = {
  hasSearch: true,
  hasSort: true,
  hasFilter: true,
  applyFilterHandler: null,
  widgetItemOperations: {},
  alertLevels: []
};

SearchSortAndFilter.propTypes = {
  hasSearch: PropTypes.bool,
  hasSort: PropTypes.bool,
  hasFilter: PropTypes.bool,
  applyFilterHandler: PropTypes.func.isRequired,
  widgetItemOperations: PropTypes.object.isRequired,
  filters: PropTypes.object,
  alertLevels: PropTypes.array.isRequired,
  moduleType: PropTypes.string
};

export default SearchSortAndFilter;
